/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt } from '../../twd/twd'
import Empty from './empty'
import Foot from './foot'

export default ({rows}) => <React.Fragment>
    {(!rows || rows.length===0) && Empty({msg:'There are no redemptions since 9/30/2011'})}

    { rows && rows.length>0 && <div className="table-responsive">
    <table
        data-name="bond-detail-events-ratings-redemptions-table"
        className="table table-striped align-top">
    <thead>
        <tr>
        <th>Date Published</th>
        <th>Event Description</th>
        </tr>
    </thead>
    <tbody>{
        rows && rows.map( (r,i) => {
            return <tr
                data-name="bond-detail-events-ratings-redemptions-row"
                key={i}>
            <td>{fmt.mdy(r.alertDate)}</td>
            <td>{r.alertDescription}</td>
            </tr>
        })
    }</tbody>
    </table>
    </div>}

    <Foot label='Redemptions' />

    </React.Fragment>